export default __webpack_public_path__ + "static/customizable_templates_for_mail_resources-e34a4f0c49e09a01673a37ec4cc9b36a.svg";